<script setup>
// Sprint AGENDAR-MSG.1 (15/07/2026): contador da janela de 24h da Meta
// (paridade Kinbox — canto inferior esquerdo do composer).
//
// Passadas 24h da ultima incoming, a Meta so aceita template APPROVED. O
// Chatwoot ja DESABILITA o editor nesse caso (ReplyBox#isEditorDisabled), mas
// nao mostra QUANTO tempo ainda resta — que e justamente o que o atendente
// precisa pra decidir se responde agora ou agenda.
//
// Fonte da verdade do aberto/fechado = `canReply` (vem do backend via
// json.can_reply -> Conversations::MessageWindowService, que conhece a regra de
// cada canal). O `expiresAt` e so pra renderizar o relogio. Se o canal nao tem
// janela (Evolution QR: agent_reply_time_window nil => can_reply sempre true),
// o pai simplesmente nao passa expiresAt e nada e renderizado.
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
  // ISO string (UTC) do momento em que a janela fecha, ou null se nao se aplica
  expiresAt: { type: String, default: null },
  canReply: { type: Boolean, default: true },
});

const now = ref(Date.now());
let timer = null;

onMounted(() => {
  timer = setInterval(() => {
    now.value = Date.now();
  }, 1000);
});

// Sem isso o interval continua vivo depois de trocar de conversa (vazamento
// classico: N conversas abertas = N timers rodando pra sempre).
onBeforeUnmount(() => {
  if (timer) clearInterval(timer);
  timer = null;
});

const msLeft = computed(() => {
  if (!props.expiresAt) return null;
  const end = new Date(props.expiresAt).getTime();
  if (Number.isNaN(end)) return null;
  return end - now.value;
});

const isClosed = computed(() => !props.canReply || (msLeft.value !== null && msLeft.value <= 0));

// Renderiza se: a janela fechou (avisa) OU temos quanto falta (conta)
const shouldRender = computed(() => {
  if (!props.expiresAt) return false;
  return true;
});

const label = computed(() => {
  if (isClosed.value) return 'Janela fechada';
  const total = Math.max(0, Math.floor(msLeft.value / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return `${h}h ${m}m ${s}s`;
});

const colorClass = computed(() => {
  if (isClosed.value) return 'text-red-600 dark:text-red-400';
  const minsLeft = msLeft.value / 60000;
  if (minsLeft < 30) return 'text-red-600 dark:text-red-400';
  if (minsLeft < 120) return 'text-amber-600 dark:text-amber-500';
  return 'text-slate-500 dark:text-slate-400';
});

const tooltip = computed(() =>
  isClosed.value
    ? 'A janela de 24h da Meta fechou — só template aprovado é aceito agora'
    : 'Tempo restante da janela de 24h da Meta para enviar mensagem livre'
);
</script>

<template>
  <div
    v-if="shouldRender"
    v-tooltip.top="tooltip"
    class="flex items-center gap-1 text-xs font-medium tabular-nums"
    :class="colorClass"
  >
    <span class="i-lucide-clock size-3.5 shrink-0" />
    <span>{{ label }}</span>
  </div>
</template>
